/* WLAM 2026 – video tự phát khi trong màn hình, clip phát khi rê chuột/chạm, dải chữ chạy.
   Chạy lại khi Theme Editor tải lại section. */
(() => {
  const small = window.matchMedia('(max-width: 749px)');

  // Video nền (hero, video dọc): chỉ phát bản đúng cỡ màn hình, chỉ khi đang thấy.
  const autoVideos = new Set();
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting && v.offsetParent !== null && !v.dataset.wlStop) {
        v.muted = true;
        const p = v.play(); if (p) p.catch(() => {});
      } else v.pause();
    });
  }, { threshold: 0.15 }) : null;

  const visible = (v) => {
    if (v.offsetParent === null && getComputedStyle(v).position !== 'fixed') return false;
    const r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
  };
  const sync = () => autoVideos.forEach((v) => {
    if (visible(v)) { if (v.paused && !v.dataset.wlStop) { v.muted = true; const p = v.play(); if (p) p.catch(() => {}); } }
    else if (!v.paused) v.pause();
  });
  let t = 0;
  const onScroll = () => { if (t) return; t = setTimeout(() => { t = 0; sync(); }, 200); };

  function setupAuto(root) {
    root.querySelectorAll('video[data-wl-auto], .wl-hero video, .wl-split__media video').forEach((v) => {
      if (autoVideos.has(v)) return;
      autoVideos.add(v);
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (io) io.observe(v);
    });
    sync();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', sync);

  // Clip: rê chuột (máy tính) hoặc chạm (điện thoại) để phát.
  function setupClips(root) {
    root.querySelectorAll('.wl-clip').forEach((el) => {
      if (el.dataset.wlReady) return; el.dataset.wlReady = '1';
      const v = el.querySelector('video'); if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
      const play = () => { v.preload = 'auto'; const p = v.play(); if (p) p.then(() => el.classList.add('is-playing')).catch(() => {}); };
      const stop = () => { v.pause(); el.classList.remove('is-playing'); };
      el.addEventListener('mouseenter', () => { if (!small.matches) play(); });
      el.addEventListener('mouseleave', () => { if (!small.matches) stop(); });
      el.querySelector('.wl-clip__media')?.addEventListener('click', (e) => {
        if (!small.matches) return;
        e.preventDefault();
        el.classList.contains('is-playing') ? stop() : play();
      });
    });
  }

  // Dải chữ: nhân đôi nội dung để chạy liền mạch.
  function setupMarquee(root) {
    root.querySelectorAll('.wl-marquee__in').forEach((m) => {
      if (m.dataset.wlReady) return; m.dataset.wlReady = '1';
      const html = m.innerHTML; let n = 0;
      while (m.scrollWidth < window.innerWidth * 2 && n++ < 8) m.innerHTML += html;
      m.innerHTML += m.innerHTML;
    });
  }

  // Video đầu trang có đoạn bóng rơi + logo WLAM ở cuối:
  // - từ brand-from tới hết vòng: ẩn tiêu đề (màn dọc: ẩn cả nút) để đoạn cao trào chiếm trọn màn hình;
  // - card-from..card-to (máy tính): nút và mục lục đổi màu than trên nền kem;
  // - sau max-loops vòng: dừng ở khung đầu, chữ hiện lại bình thường.
  function setupHeroBrand(root) {
    root.querySelectorAll('.wl-hero[data-brand-from]').forEach((hero) => {
      if (hero.dataset.wlBrand) return; hero.dataset.wlBrand = '1';
      const num = (k, d) => { const n = parseFloat(hero.dataset[k]); return isFinite(n) ? n : d; };
      const fromLg = num('brandFrom', 0), fromSm = num('brandFromSm', fromLg), to = num('brandTo', 1e9) || 1e9;
      const cardFrom = num('cardFrom', 1e9), cardTo = num('cardTo', 1e9), maxLoops = num('maxLoops', 0);
      if (!(fromLg > 0)) return;
      let raf = 0, last = -1, loops = 0;
      const clear = () => hero.classList.remove('is-brand', 'is-card');
      // update() reads the playing video's time; driven by rAF for precision, with timeupdate as a fallback
      const update = () => {
        const v = [...hero.querySelectorAll('video')].find((x) => x.offsetParent !== null && !x.paused);
        if (!v) { clear(); return false; }
        const t = v.currentTime;
        if (last >= 0 && t < last - 1) {
          loops++;
          if (maxLoops > 0 && loops >= maxLoops) {
            v.dataset.wlStop = '1'; v.pause(); v.currentTime = 0; clear(); last = -1; return false;
          }
        }
        last = t;
        const sm = v.classList.contains('wl-hero__media--sm');
        const focus = hero.querySelector('.wl-hero__copy')?.matches(':focus-within');
        const on = !focus && t >= (sm ? fromSm : fromLg) && t < to;
        hero.classList.toggle('is-sm', sm);
        hero.classList.toggle('is-brand', on);
        hero.classList.toggle('is-card', on && !sm && t >= cardFrom && t < cardTo);
        return true;
      };
      const tick = () => { raf = 0; if (update()) raf = requestAnimationFrame(tick); };
      hero.querySelectorAll('video').forEach((v) => {
        v.addEventListener('play', () => { if (!raf) raf = requestAnimationFrame(tick); });
        v.addEventListener('timeupdate', update);
        v.addEventListener('pause', clear);
      });
      if (!raf) raf = requestAnimationFrame(tick);
    });
  }

  function init(root = document) { setupAuto(root); setupClips(root); setupMarquee(root); setupHeroBrand(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  small.addEventListener?.('change', () => autoVideos.forEach((v) => { if (v.offsetParent === null) v.pause(); else if (io) { io.unobserve(v); io.observe(v); } }));
})();
